import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Card, CardActionArea, CardContent, Typography, useMediaQuery } from '@mui/material/'
import { Date } from '@components/organisms/Article/Date'
import { ArticlesFragment } from '@services/graphcms/client'

const PREFIX = 'FeedListWithoutImage'

const classes = {
  card: `${PREFIX}-card`,
}

const StyledCard = styled(Card)(() => ({
  [`&.${classes.card}`]: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

type Props = {
  article: ArticlesFragment
}

export function FeedListWithoutImage(props: Props) {
  const theme = useTheme()
  const router = useRouter()
  const isPcScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <StyledCard className={classes.card} elevation={0} variant="outlined">
      <CardActionArea onClick={() => router.push(`/article/${props.article.id}`)}>
        <CardContent>
          <Typography variant={isPcScreen ? 'h6' : 'subtitle1'}>{props.article.title}</Typography>
          <Date article={props.article} fullYear={true} />
        </CardContent>
      </CardActionArea>
    </StyledCard>
  )
}
